import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { legacyWorkspaceSearch } from '../-search'

function positiveRouteID(value: string, label: string): number {
  const parsed = Number(value)
  if (!Number.isSafeInteger(parsed) || parsed <= 0) throw new Error(`${label} must be a positive integer`)
  return parsed
}

// Every chat URL written before the split lands here. The workspace owns the address
// now, so this route only translates: the conversation becomes `chat=`, and whatever
// `panel=` shape came with it becomes `doc=` or `inspect=`. ADR-167.
export const Route = createFileRoute('/_auth/$orgSlug/$projectId/chat/$conversationId/')({
  validateSearch: z.record(z.string(), z.unknown()),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$orgSlug/$projectId/workspace',
      params: { orgSlug: params.orgSlug, projectId: params.projectId },
      search: legacyWorkspaceSearch(search, positiveRouteID(params.conversationId, 'conversationId')),
      replace: true
    })
  },
  component: () => null
})
